import React from "react";
import "../MarketingForm.css";

const DealsFilter = ({ filters, setFilters }) => {
  
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  return (
    <div className="row mb-4">
      <div className="col-md-4">
        <input
          type="text"
          name="deal_name"
          className="form-control mt-2"
          style={{ border: "1px solid #E7E5E4", padding: "5px 15px" }}
          placeholder="Filter by Deal Name"
          value={filters.deal_name}
          onChange={handleFilterChange}
        />
      </div>
      <div className="col-md-4">
        <input
          type="text"
          name="deal_status"
          className="form-control mt-2"
          style={{ border: "1px solid #E7E5E4", padding: "5px 15px" }}
          placeholder="Filter by Status"
          value={filters.deal_status}
          onChange={handleFilterChange}
        />
      </div>
      <div className="col-md-4">
        <input
          type="text"
          name="hospital_name"
          className="form-control mt-2"
          style={{ border: "1px solid #E7E5E4", padding: "5px 15px" }}
          placeholder="Filter by Hospital Name"
          value={filters.hospital_name}
          onChange={handleFilterChange}
        />
      </div>

      
    </div>
  );
};

export default DealsFilter;
